export const MAX_FILES = 10;
export const IMAGE_MAX_FILE_SIZE = 20 * 1024 * 1024; // 20MB
export const FILE_MAX_FILE_SIZE = 100 * 1024 * 1024; // 100MB
